import { render } from "./StagesView.vue?vue&type=template&id=4d894ab0&scoped=true"
import script from "./StagesView.vue?vue&type=script&lang=js"
export * from "./StagesView.vue?vue&type=script&lang=js"

import "./StagesView.vue?vue&type=style&index=0&id=4d894ab0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d894ab0"]])

export default __exports__